import React from "react";


const AssetConfiguration = ({assetOverview}) => {
    const renderFrequencyDetails = (contractDetails) => {
        if (!contractDetails) return null;
    
        const frequency = contractDetails.frequency;
        const time = contractDetails.time;
        const daysOfWeek = contractDetails.daysOfWeek;
        const dayOfMonth = contractDetails.dayOfMonth;
        const selectedPeriods = contractDetails.selectedPeriods;
    
        // Helper to format days of week
        const formatDaysOfWeek = (days) => {
          if (!days || days === "") return "N/A";
          if (Array.isArray(days)) return days.join(", ");
          if (typeof days === "string") {
            // If it's comma separated string
            return days
              .split(",")
              .map((d) => d.trim())
              .join(", ");
          }
          return days;
        };
    
        // Helper to format periods
        const formatPeriods = (periods) => {
          if (!periods || periods === "") return "N/A";
          if (Array.isArray(periods)) return periods.join(", ");
          if (typeof periods === "string") {
            return periods
              .split(",")
              .map((p) => p.trim())
              .join(", ");
          }
          return periods;
        };
    
        const frequencyConfig = {
          Hourly: [{ label: "Frequency", value: frequency || "N/A" }],
          Daily: [
            { label: "Frequency", value: frequency || "N/A" },
            { label: "Time", value: time ? `${time} UTC` : "N/A" },
          ],
          Weekly: [
            { label: "Frequency", value: frequency || "N/A" },
            { label: "Days of Week", value: formatDaysOfWeek(daysOfWeek) },
            { label: "Time", value: time ? `${time} UTC` : "N/A" },
          ],
          "Mars Periodic": [
            { label: "Frequency", value: frequency || "N/A" },
            { label: "Day", value: dayOfMonth || "N/A" },
            { label: "Time", value: time ? `${time} UTC` : "N/A" },
          ],
          "Mars Quarter": [
            { label: "Frequency", value: frequency || "N/A" },
            { label: "Periods", value: formatPeriods(selectedPeriods) },
            { label: "Day of Period", value: dayOfMonth || "N/A" },
            { label: "Time", value: time ? `${time} UTC` : "N/A" },
          ],
          "Mars Year": [
            { label: "Frequency", value: frequency || "N/A" },
            { label: "Periods", value: formatPeriods(selectedPeriods) },
            { label: "Day of Period", value: dayOfMonth || "N/A" },
            { label: "Time", value: time ? `${time} UTC` : "N/A" },
          ],
          "Mars Half-Yearly": [
            { label: "Frequency", value: frequency || "N/A" },
            { label: "Periods", value: formatPeriods(selectedPeriods) },
            { label: "Day of Period", value: dayOfMonth || "N/A" },
            { label: "Time", value: time ? `${time} UTC` : "N/A" },
          ],
        };
        const fieldsToDisplay = frequencyConfig[frequency] || [
          { label: "Frequency", value: frequency || "N/A" },
        ];
    
        return (
          <div className="grid grid-cols-2 gap-4">
            {fieldsToDisplay.map((field, index) => (
              <div key={index} className="bg-gray-50 p-4 rounded-lg">
                <div className="text-sm text-gray-600 mb-1">{field.label}</div>
                <div className="text-base font-semibold text-gray-900">
                  {field.value}
                </div>
              </div>
            ))}
          </div>
        );
      };
    return(
        <>
         <div>
                <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center">
                  <div className="w-[5px] h-6 bg-purple-600 rounded mr-3"></div>
                  Frequency
                </h3>
                {renderFrequencyDetails(assetOverview)}
              </div>
        </>
    )
}

export default AssetConfiguration;